module.exports = "/assets/data/3e672d81d54b715c9b6dacb5c93c0147-GU34.data.json";